<template>
    <div>
        <ui-modal v-ref:pre-append-items-modal :width="800">
            <div slot="header">
                Em qual visita você deseja adicionar?
            </div>
            <div>
                <ui-loading :state="preAppendItemsForm.loading">
                    <div class="well well-lg text-center"
                         v-if="preAppendItemsForm.visits && preAppendItemsForm.visits.length < 1">
                        Não há visitas.
                    </div>
                    <div v-if="preAppendItemsForm.visits && preAppendItemsForm.visits.length > 0">
                        <div class="timeline timeline-minimal">
                            <div v-for="visit in preAppendItemsForm.visits" class="timeline-item-wrapper">
                                <div class="timeline-item">
                                    <div class="timeline-body-wrapper">
                                        <div class="timeline-body" style="margin-left: 0">
                                            <visit-item :visit.sync="visit" :on-selected="preAppendVisitSelected"></visit-item>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ui-loading>
            </div>
        </ui-modal>
        <ui-modal v-ref:statement-modal :backdrop-clickable="false">
            <div slot="header">
                Qual será a data do termo?
            </div>
            <div>
                <ui-loading :state="loading">
                    <form-datetime :time="false" :model.sync="visitStatement.date" label="Data"></form-datetime>
                    <form-remote-select url="/users" :query="{'sort': {'name': 'asc'}}" label="Corretor do termo" :model.sync="visitStatement.user" :allow-empty="false"></form-remote-select>
                </ui-loading>
            </div>
            <div slot="footer">
                <button :disabled="loading" class="btn btn-default" @click="$refs.statementModal.hide()">
                    Cancelar
                </button>
                <button :disabled="loading" class="btn btn-primary" @click="openVisitStatement()">
                    Criar declaração
                </button>
            </div>
        </ui-modal>
        <ui-modal v-ref:view-modal :width="900">
            <div>
                <ui-loading :state="loading">
                    <div v-if="!visit.comment">
                        <h3 style="text-align: center; padding: 30px">
                            Não houve feedback nessa visita
                        </h3>
                    </div>
                    <div v-if="visit.comment">
                        <div>
                            <label>Feedback geral da visita:</label>
                            <div style="font-style: italic; border-left: 4px solid #428bca; padding: 8px; margin-bottom: 8px;">
                                <inline-html-sandbox :html="visit.comment"></inline-html-sandbox>
                            </div>
                        </div>
                        <div style="margin-bottom: 15px">
                            <h4>
                                Sobre os imóveis <b>({{ items.length }})</b>
                            </h4>
                        </div>
                        <div style="max-height: 400px; overflow: auto" data-name="visit" class="pseudo-form">
                            <div v-for="(index, row) in visit.items" :key="index" class="report-properties-item">
                                <div style="margin-bottom: 15px; background-color: #E5E5E5; padding: 8px;" v-if="row" >
                                    <div>
                                        Cod. <b>{{ row.item.userCode }}</b>
                                    </div>
                                    <div>
                                        <property-line v-if="row.item" :property="row.item" name="simple-description"></property-line>
                                    </div>
                                    <div>
                                        <property-line v-if="row.item" :property="row.item" name="address"></property-line>
                                    </div>
                                </div>
                                <div style="position: relative; display: flex; min-height: 75px" v-if="row">
                                    <div style="width: 200px">
                                        <grid-media :row="row.item" :padding="8"></grid-media>
                                    </div>
                                    <div style="margin-left: 15px; width: 100%;">
                                        <div style="display: flex" v-if="row.status === 3">
                                            <div style="width: 100%">
                                                <label>Esse imóvel não foi visitado, motivo:</label>
                                                <div style="font-style: italic; border-left: 4px solid #cb5a5e; padding: 8px; margin-bottom: 8px;">
                                                    <html-sandbox :html="row.comment"></html-sandbox>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="row.status !== 3">
                                            <div style="display: flex">
                                                <div style="width: 100%">
                                                    <label>Feedback da visita ao imóvel:</label>
                                                    <div v-if="!row.comment" class="text-muted">
                                                        Não houve feedback nesse imóvel
                                                    </div>
                                                    <div v-if="row.comment" style="font-style: italic; border-left: 4px solid #428bca; padding: 8px; margin-bottom: 8px;">
                                                        <html-sandbox :html="row.comment"></html-sandbox>
                                                    </div>
                                                </div>
                                                <div style="width: 260px; flex-shrink: 0; margin-left: 15px; display: flex;">
                                                    <div style="width: 100%; align-items: center;">
                                                        <div style="margin-bottom: 8px; height: 34px; display: flex; align-items: center;">Preço</div>
                                                        <div style="margin-bottom: 8px; height: 34px; display: flex; align-items: center;">Localização</div>
                                                        <div style="margin-bottom: 8px; height: 34px; display: flex; align-items: center;">Estado do Imóvel</div>
                                                    </div>
                                                    <div style="width: 120px; flex-shrink: 0;">
                                                        <div style="margin-bottom: 8px">
                                                            <form-fake-text :model.sync="row.price_rating"></form-fake-text>
                                                        </div>
                                                        <div style="margin-bottom: 8px">
                                                            <form-fake-text :model.sync="row.location_rating"></form-fake-text>
                                                        </div>
                                                        <div style="margin-bottom: 8px">
                                                            <form-fake-text :model.sync="row.condition_rating"></form-fake-text>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <hr style="margin: 8px 0">
                                            <div style="display: flex">
                                                <div style="width: 100%">
                                                </div>
                                                <div style="width: 260px; flex-shrink: 0; margin-left: 15px; display: flex">
                                                    <div style="display: flex; width: 100%; align-items: center;">Avaliação geral</div>
                                                    <div style="width: 120px; flex-shrink: 0;">
                                                        <div class="btn-group" style="display: flex">
                                                            <button :class="{green: row.general_rating === 10}"
                                                                    type="button"
                                                                    class="btn default"
                                                                    style="width: 100%"
                                                                    @click="row.general_rating = 10"
                                                                    disabled>
                                                                <i class="fa fa-thumbs-up"></i>
                                                            </button>
                                                            <button :class="{red: row.general_rating === 0}"
                                                                    type="button"
                                                                    class="btn default"
                                                                    style="width: 100%"
                                                                    @click="row.general_rating = 0"
                                                                    disabled>
                                                                <i class="fa fa-thumbs-down"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="$index < (items.length - 1)" style="height: 4px; margin-top: 15px; margin-bottom: 15px; background-color: #c2ced3"></div>
                            </div>
                        </div>
                    </div>
                </ui-loading>
            </div>
            <div slot="footer">
                <button class="btn default" type="button" @click.prevent="$refs.viewModal.hide()" :disabled="loading">
                    Fechar
                </button>
            </div>
        </ui-modal>
        <ui-modal v-ref:finish-modal :width="900" :backdrop-clickable="false">
            <div>
                <ui-loading :state="loading">
                    <form-context name="visit">
                        <div style="margin-bottom: 15px">
                            <h4 v-if="mode === 'finish'">
                                Que ótimo. Então nos dê o feedback de como foi a visita
                            </h4>
                            <h4 v-if="mode === 'cancel'">
                                Que pena, nos informe o motivo.
                            </h4>
                        </div>
                        <div v-if="mode === 'cancel'">
                            <div>
                                <form-textarea v-ref:title
                                               rows="5"
                                               :model.sync="visit.comment"
                                               name="comment"
                                               placeholder="Informe aqui o motivo do cancelamento"></form-textarea>
                            </div>
                        </div>
                        <div v-if="mode === 'finish'">
                            <div>
                                <form-textarea v-ref:title
                                            rows="5"
                                            :model.sync="visit.comment"
                                            name="comment"
                                            placeholder="Informe aqui o feedback geral da visita"></form-textarea>
                            </div>
                            <div style="margin-bottom: 15px">
                                <h4>
                                    Sobre os imóveis <b>({{ items.length }})</b>
                                </h4>
                            </div>
                            <div style="max-height: 400px; overflow: auto" data-name="visit" class="pseudo-form">
                                <form-context name="items" append>
                                    <div v-for="row in items" class="report-properties-item">
                                        <form-context :name="$index" append>
                                            <div style="margin-bottom: 15px; background-color: #E5E5E5; padding: 8px;" v-if="row.type === 'PROPERTY'" >
                                                <div>
                                                    Cod. <b>{{ row.item.userCode }}</b>
                                                </div>
                                                <div>
                                                    <property-line :property="row.item" name="simple-description"></property-line>
                                                </div>
                                                <div>
                                                    <property-line :property="row.item" name="address"></property-line>
                                                </div>
                                            </div>
                                            <div style="margin-bottom: 15px; background-color: #E5E5E5; padding: 8px;"  v-if="row.type === 'CONSTRUCTION'">
                                                <div>
                                                    Cod. <b>{{ row.item.user_code }}</b>
                                                </div>
                                                <div>
                                                    <construction-line :construction="row.item" name="simple-description"></construction-line>
                                                </div>
                                                <div>
                                                    <construction-line :construction="row.item" name="address"></construction-line>
                                                </div>
                                            </div>
                                            <div style="position: relative; display: flex; min-height: 75px">
                                                <div style="width: 200px">
                                                    <grid-media :row="row.item" :padding="8" v-if="row.type === 'PROPERTY'"></grid-media>
                                                    <construction-media :construction="row.item" v-if="row.type === 'CONSTRUCTION'"></construction-media>
                                                </div>
                                                <div style="margin-left: 15px; width: 100%;">
                                                    <div v-if="row.status === 3">
                                                        <div style="display: flex">
                                                            <div style="width: 100%">
                                                                <form-textarea :model.sync="row.comment"
                                                                            name="comment"
                                                                            rows="5"
                                                                            placeholder="Por que o imóvel não foi visitado?"></form-textarea>
                                                            </div>
                                                        </div>
                                                        <hr style="margin: 8px 0">
                                                        <div style="display: flex">
                                                            <div style="width: 100%">
                                                                <button @click="visited(row)" type="button" class="btn default">
                                                                    Visitamos
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="row.status === 2">
                                                        <div style="display: flex">
                                                            <div style="width: 100%">
                                                                <form-textarea :model.sync="row.comment"
                                                                            name="comment"
                                                                            rows="5"
                                                                            placeholder="Feedback da visita ao imóvel"></form-textarea>
                                                            </div>
                                                            <div style="width: 260px; flex-shrink: 0; margin-left: 15px">
                                                                <div>
                                                                    <div style="display: flex">
                                                                        <div style="height: 34px; display: flex; align-items: center; width: 100%">Preço</div>
                                                                        <select class="form-control" v-model="row.price_rating" v-el:price-rating style="width: 120px; flex-shrink: 0; margin: 0">
                                                                            <option :value="null">Selecione</option>
                                                                            <option v-for="rating in ratings" :value="rating.value">
                                                                                {{ rating.name }}
                                                                            </option>
                                                                        </select>
                                                                    </div>
                                                                    <div style="margin: 5px 0; font-size: 13px;">
                                                                        <form-errors :fields="['price_rating']" :on-error="$els.priceRating.focus()" :head="true"></form-errors>
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <div style="display: flex">
                                                                        <div style="height: 34px; display: flex; align-items: center; width: 100%">Localização</div>
                                                                        <select class="form-control" v-model="row.location_rating" v-el:location-rating style="width: 120px; flex-shrink: 0">
                                                                            <option :value="null">Selecione</option>
                                                                            <option v-for="rating in ratings" :value="rating.value">
                                                                                {{ rating.name }}
                                                                            </option>
                                                                        </select>
                                                                    </div>
                                                                    <div style="margin: 5px 0; font-size: 13px;">
                                                                        <form-errors :fields="['location_rating']" :on-error="$els.locationRating.focus()" :head="true"></form-errors>
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <div style="display: flex">
                                                                        <div style="height: 34px; display: flex; align-items: center; width: 100%">Estado do Imóvel</div>
                                                                        <select class="form-control" v-model="row.condition_rating" v-el:condition-rating style="width: 120px; flex-shrink: 0">
                                                                            <option :value="null">Selecione</option>
                                                                            <option v-for="rating in ratings" :value="rating.value">
                                                                                {{ rating.name }}
                                                                            </option>
                                                                        </select>
                                                                    </div>
                                                                    <div style="margin: 5px 0; font-size: 13px;">
                                                                        <form-errors :fields="['condition_rating']" :on-error="$els.conditionRating.focus()" :head="true"></form-errors>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <hr style="margin: 8px 0">
                                                        <div style="display: flex">
                                                            <div style="width: 100%">
                                                                <button @click="notVisited(row)" type="button" class="btn default">
                                                                    Não visitamos
                                                                </button>
                                                            </div>
                                                            <div style="width: 260px; flex-shrink: 0; margin-left: 15px; display: flex">
                                                                <div style="display: flex; width: 100%; align-items: center;">Avaliação geral</div>
                                                                <div style="width: 120px; flex-shrink: 0;">
                                                                    <div class="btn-group" style="display: flex">
                                                                        <button :class="{green: row.general_rating === 10}"
                                                                                type="button"
                                                                                class="btn default"
                                                                                style="width: 100%"
                                                                                @click="row.general_rating = 10">
                                                                            <i class="fa fa-thumbs-up"></i>
                                                                        </button>
                                                                        <button :class="{red: row.general_rating === 0}"
                                                                                type="button"
                                                                                class="btn default"
                                                                                style="width: 100%"
                                                                                @click="row.general_rating = 0">
                                                                            <i class="fa fa-thumbs-down"></i>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form-context>
                                        <div v-if="$index < (items.length - 1)" style="height: 4px; margin-top: 15px; margin-bottom: 15px; background-color: #c2ced3"></div>
                                    </div>
                                </form-context>
                            </div>
                        </div>
                    </form-context>
                </ui-loading>
            </div>
            <div slot="footer">
                <button class="btn blue" v-if="loading" type="button" @click.prevent="save('finish')" :disabled="loading || submitting">
                    <i class="fa fa-circle-o-notch fa-spin"></i>
                    Carregando...
                </button>

                <button class="btn default" v-if="!loading && (visit && visit.status === 1)" type="button" @click.prevent="$refs.finishModal.hide()" :disabled="loading || submitting">
                    Fechar
                </button>
                <button class="btn blue" v-if="!loading && (visit && visit.status === 1)" type="button" @click.prevent="save('finish')" :disabled="loading || submitting">
                    <i class="fa fa-check"></i>
                    Finalizar Visita
                </button>

                <button class="btn default" v-if="!loading && (visit && visit.status === 2)" type="button" @click.prevent="$refs.finishModal.hide()" :disabled="loading || submitting">
                    Fechar
                </button>
                <button class="btn blue" v-if="!loading && (visit && visit.status === 2)" type="button" @click.prevent="save('finish')" :disabled="loading || submitting">
                    <i class="fa fa-save"></i>
                    Salvar Alterações
                </button>

                <button class="btn default" v-if="!loading && (visit && visit.status === 3)" type="button" @click.prevent="$refs.finishModal.hide()" :disabled="loading || submitting">
                    Fechar
                </button>
                <button class="btn red" v-if="!loading && (visit && visit.status === 3)" type="button" @click.prevent="save('cancel')" :disabled="loading || submitting">
                    <i class="fa fa-close"></i>
                    Cancelar Visita
                </button>
            </div>
        </ui-modal>
        <ui-modal v-ref:modal :width="800" :backdrop-clickable="false">
            <div slot="header">
                <div v-if="mode === 'create'">
                    Agendar Visita
                </div>
                <div v-if="mode === 'update'">
                    Atualizar Visita
                </div>
            </div>
            <div>
                <ui-loading :state="loading">
                    <form @submit.prevent="save()" v-el:form name="visit">
                        <div>
                            <form-text :autofocus="true" v-ref:title :model.sync="visit.name"
                                       placeholder="Titulo da atividade, padrão: 'Visita'"></form-text>
                        </div>
                        <div style="display: flex" class="dates">
                            <form-datetime :model.sync="visit.date"
                                           :time="false"
                                           :from-today="true"
                                           placeholder="Data"></form-datetime>
                            <form-datetime :disabled="!visit.date"
                                           :model.sync="visit.start_time"
                                           :date="false"
                                           placeholder="Hora inicial"
                                           :start-time-at="visitBaseTime"></form-datetime>
                            <form-datetime :disabled="!visit.date"
                                           :model.sync="visit.end_time"
                                           :date="false"
                                           :start-time-at="visit.start_time"
                                           placeholder="Hora final"></form-datetime>
                        </div>
                        <div>
                            <form-editor :autofocus="false"
                                         :model.sync="visit.description"
                                         placeholder="Descrição da atividade"
                                         :height="100"></form-editor>
                        </div>
                        <button type="submit" class="hidden-submit-input"></button>
                    </form>
                    <div style="margin-bottom: 10px; margin-top: 10px; display: flex; align-items: center">
                        <div style="width: 100%">Imóveis <b>({{ items.length }})</b></div>
                        <div>
                            <div v-if="addPropertyForm.loading" style="text-align: right">
                                Carregando...
                            </div>
                            <form @submit.prevent="addProperty()" v-if="!addPropertyForm.loading">
                                <form-context name="addPropertyForm">
                                    <div class="form-group" style="margin: 0">
                                        <div class="input-group" style="min-width: 230px; width: 230px; max-width: 300px;">
                                            <input v-model="addPropertyForm.code"
                                                   v-el:add-property-code
                                                   class="form-control"
                                                   placeholder="Código do imóvel"/>
                                            <span class="input-group-btn">
                                                <button type="submit" class="btn blue">Adicionar</button>
                                            </span>
                                        </div>
                                        <form-errors :fields="['code']"></form-errors>
                                    </div>
                                </form-context>
                            </form>
                        </div>
                    </div>
                    <div style="max-height: 250px; overflow: auto">
                        <div v-for="row in visit.items" class="bg-grey-steel properties-item">
                            <div style="position: relative; display: flex; min-height: 75px">
                                <div style="width: 100px">
                                    <grid-media :row="row.item" :padding="8" v-if="row.type === 'PROPERTY'"></grid-media>
                                    <construction-media :construction="row.item" :padding="8" v-if="row.type === 'CONSTRUCTION'"></construction-media>
                                </div>
                                <div style="margin-left: 8px; width: 100%;" v-if="row.item.itemType === 'PROPERTY'">
                                    <div>
                                        Cod. <b>{{ row.item.userCode }}</b>
                                    </div>
                                    <div>
                                        <property-line v-if="" :property="row.item" name="simple-description"></property-line>
                                    </div>
                                    <div>
                                        <property-line :property="row.item" name="address"></property-line>
                                    </div>
                                </div>
                                <div style="margin-left: 8px; width: 100%;" v-if="row.type === 'CONSTRUCTION'">
                                    <div>
                                        Cod. <b>{{ row.item.userCode }}</b>
                                    </div>
                                    <div>
                                        <construction-line  :construction="row.item" name="simple-description"></construction-line>
                                    </div>
                                    <div>
                                        <construction-line  :construction="row.item" name="address"></construction-line>
                                    </div>
                                </div>
                                <div class="order" v-if="items.length > 1">
                                    <span v-if="mode === 'update' && row.id === 0"
                                          class="badge badge-info" style="margin-right: 5px;">
                                        NOVO
                                    </span>
                                    <span><b>{{ row.position }}º</b></span>
                                </div>


                                <div class="directions" v-if="items.length > 1">
                                    <button type="button" @click.prevent="moveUp(row)"
                                            :disabled="row.position === 1">
                                        <span class="fa fa-chevron-up"></span>
                                    </button>
                                    <button type="button" @click.prevent="remove(row)">
                                        <span class="fa fa-trash"></span>
                                    </button>
                                    <button type="button" @click.prevent="moveDown(row)"
                                            :disabled="row.position === visit.items.length">
                                        <span class="fa fa-chevron-down"></span>
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </ui-loading>
            </div>
            <div slot="footer">
                <button v-if="mode === 'create'" class="btn blue" type="button" @click.prevent="save()" :disabled="loading || submitting">
                    <i class="fa fa-calendar"></i>
                    Agendar
                </button>
                <button v-if="mode === 'update'" class="btn blue" type="button" @click.prevent="save()" :disabled="loading || submitting">
                    <i class="fa fa-calendar"></i>
                    Atualizar
                </button>
            </div>
        </ui-modal>
    </div>
</template>
<style scoped>
    .dashed-children {
        font-size: 0;
    }

    .dashed-children > * {
        font-size: 14px;
    }

    .dashed-children > span:after {
        content: ' - ';
        display: inline-block;
        margin-left: 4px;
        margin-right: 4px;
    }

    .dashed-children > span:last-of-type:after {
        display: none;
    }

    .properties-item {
        padding: 8px;
        margin-bottom: 8px;
    }

    .properties-item .order {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        white-space: nowrap;
        word-break: keep-all;
        padding-left: 5px;
        padding-right: 5px;
    }

    .properties-item .directions {
        margin-top: -6px;
        margin-right: -6px;
        margin-bottom: -8px;
        width: 25px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        flex-direction: column;
    }

    .properties-item .directions > button {
        padding: 0;
        background-color: white;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        border: 0;
        margin-bottom: 2px;
    }

    .properties-item:last-of-type {
        margin-bottom: 0;
    }

    .report-properties-item:not(:last-of-type) {

    }

    .dates > .form-group {
        margin-right: 15px;
        width: 100%;
        flex-grow: 0;
    }

    .dates > .form-group:last-of-type {
        margin-right: 0;
    }
</style>
<script>
import { DebounceQueue } from "../../sci/helpers";
import ConstructionLine from "../construction/Line.vue";
import ConstructionMedia from "../construction/ConstructionMedia.vue";

    const toastr = require('toastr')
    const Vue = require('vue')
    const moment = require('moment')
    const R = require('ramda')
    const Promise = require('bluebird')
    const { client, searchClient } = require('sci/helpers')
    const { isoDate, sqlDate, formatDate } = require('sci/utils')
    const v = require('sci/helpers/new-validator')
    const bus = require('sci/std/bus')

    const ratings = R.range(0, 11).map((r) => {
        return { value: r, name: r }
    })

    const visitSchema = {
        name: 'create-visit-form',
        schema: {
            properties: {
                id: v.number,
                status: v.number,
                name: v.nonEmptyString,
                description: v.string,
                date: v.date,
                start_time: v.time,
                end_time: v.optionalTime,
                items: v.arrayOf(v.shape({
                    id: v.number,
                    type: v.nonEmptyString,
                    item_id: v.number,
                    meta: v.any,
                    position: v.number,
                    deleted: v.boolean,
                    comment: v.string,
                    condition_rating: v.number,
                    general_rating: v.number,
                    price_rating: v.number,
                }))
            },
            required: ['id', 'name', 'date', 'start_time']
        },
        messages: {
            'name': 'Este campo precisa ser preenchido.',
            'date': 'Este campo precisa ser preenchido.',
            'start_time': 'Este campo precisa ser preenchido.'
        }
    }

    const visitFinishSchema = {
        name: 'finish-visit-form',
        schema: {
            properties: {
                id: v.number,
                status: v.number,
                name: v.string,
                comment: v.string,
                description: v.string,
                date: v.date,
                start_time: v.time,
                end_time: v.optionalTime,
                items: v.arrayOf(v.shape({
                    id: v.number,
                    type: v.string,
                    item_id: v.number,
                    meta: v.any,
                    position: v.number,
                    status: v.number,
                    general_rating: v.number,
                    price_rating: v.number,
                    location_rating: v.number,
                    condition_rating: v.number,
                    comment: v.string,
                    deleted: v.boolean
                }, [
                    //'comment',
                    //'general_rating', 'price_rating', 'location_rating', 'condition_rating'
                ]))
            },
            required: ['id', 'name', 'date', 'start_time', 'comment']
        },
        messages: {
            '**': 'Este campo precisa ser preenchido.',
            'items/*': {
                // price_rating: 'Este campo precisa ser preenchido.',
                // location_rating: 'Este campo precisa ser preenchido.',
                // condition_rating: 'Este campo precisa ser preenchido.',
                // general_rating: 'Este campo precisa ser preenchido.',
            },
        }
    }

    const visitCancelSchema = {
        name: 'cancel-visit-form',
        schema: {
            properties: {
                id: v.number,
                status: v.number,
                name: v.string,
                comment: v.string,
                items: v.arrayOf(v.shape({
                    id: v.number,
                    type: v.string,
                    item_id: v.number,
                    meta: v.any,
                    position: v.number,
                    status: v.number,
                    general_rating: v.number,
                    price_rating: v.number,
                    location_rating: v.number,
                    condition_rating: v.number,
                    deleted: v.boolean
                }, ['id']))
            },
            required: ['id', 'name']
        },
        messages: {
            '**': 'Este campo precisa ser preenchido.'
        }
    }

    const defaultVisit = () => {
        const base = moment.utc().add(1, 'day')

        const startTime = '10:00:00'
        const endTime = '11:00:00'

        return {
            id: 0,
            status: 1,
            name: null,
            description: null,
            date: sqlDate(base),
            start_time: startTime,
            end_time: endTime,
            items: []
        }
    }

    // <editor-fold defaultstate="collapsed" desc="propertiesQuery">
    const propertiesQuery = `
        query ($request: PropertiesRequest!) {
          result: properties(request: $request) {
            total
            totalUnfiltered
            fromOffset
            toOffset
            remaining
            totalOnPage
            totalOfPages
            currentPage
            itemsPerPage
            hasMore
            items {
              id
              editable
              deletable
              id
              code
              userCode
              draft
              photos {
                id
                position
                description
                name
                path
                mime
                size
                width
                height
                url
                thumbnails {
                  wmedium
                }
              }
              photo {
                id
                position
                description
                name
                path
                mime
                size
                width
                height
                url
                thumbnails {
                  wmedium
                  medium
                  small
                }
              }
              videos {
                id
                url
                thumbnail
              }
              statusInfo {
                id
                name
              }
              status
              code
              alternativeCode
              typeInfo {
                id
                name
              }
              subtypeInfo {
                id
                name
              }
              street
              streetNumber
              complementary
              neighborhood {
                id
                name
              }
              city {
                id
                name
                state {
                  id
                  name
                  abbreviation
                }
              }
              building {
                id
                name
                type
              }
              condominiumName
              sellPrice
              rentPrice
              dormCount
              suitCount
              carGarageCount
              createdAt
              updatedAt
              totalArea
              totalUsefulArea
              forRent
              forSale
              forVacation
              forLease
            }
          }
        }
    `
    // </editor-fold>

    export default {
        props: {
            onCreate: {
                type: Function
            },
            onUpdate: {
                type: Function
            }
        },
        components: {
            ConstructionMedia,
            ConstructionLine,
            GridMedia: require('components/property/Media.vue'),
            PropertyLine: require('components/property/Line.vue'),
            VisitItem: require('./VisitAppendItems/VisitItem.vue'),
        },
        data () {
            return {
                ratings,
                form: null,
                mode: 'create',
                state: false,
                loading: true,
                submitting: false,
                visit: defaultVisit(),
                visitStatement: {
                    date: isoDate(moment()),
                    user: null
                },
                addPropertyForm: {
                    code: null
                },
                preAppendItemsForm: {
                    visits: [],
                    items: [],
                    loading: false
                },
                visitBaseTime: '00:00:00'
            }
        },
        ready () {
            // this.finish(18741951, 12138846)
            // this.update(18741951, 12138846)
            // this.create(18741951, [14979326, 14979321, 14979248, 14980247, 14979268, 14979259])
            // this.create(18741951, [14979326, 14979321])
        },
        watch: {
            'visit.date' (newValue) {
                const today = moment()
                const todayDate = today.format('YYYY-MM-DD')
                const todayTime = today.format('HH:mm:ss')
                this.visitBaseTime = '00:00:00'
                if (newValue === todayDate) {
                    if (this.visit.start_time < todayTime) {
                        let start = null
                        if (todayTime < '23:00:00') {
                            start = today.startOf('hour').add(1, 'hour').format('HH:mm:ss')
                        } else {
                            start = today.startOf('hour').format('HH:mm:ss')
                        }
                        this.visitBaseTime = start;
                        this.visit.start_time = start;
                    }
                }
            },
            'visit.start_time' (newValue) {
                if (this.visit.end_time < newValue) {
                    if (newValue < '23:00:00') {
                        const m = moment(`1970-01-01 ${newValue}`)

                        this.visit.end_time = m.add(1, 'hour').format('HH:mm:ss');
                    } else {
                        this.visit.end_time = newValue
                    }
                }
            }
        },
        computed: {
            items () {
                return R.pipe(
                    R.filter((r) => !r.deleted),
                    R.sortBy((r) => r.position)
                )(this.visit.items)
            }
        },
        methods: {
            hide () {
                this.$refs.modal.hide()
                this.$refs.finishModal.hide()
            },
            save (_mode) {
                const mode = _mode || this.mode
                let schema = visitSchema

                if (mode === 'finish') {
                    schema = visitFinishSchema
                } else if (mode === 'cancel') {
                    schema = visitCancelSchema
                }

                this.submitting = true

                const visitForm = Vue.util.extend({}, this.visit)

                if (!visitForm.name) {
                    visitForm.name = 'Visita'
                }

                this.$chaos('visit', this.$validate(schema, visitForm)).then((valid) => {
                    const visit = {
                        id: valid.id,
                        status: valid.status,
                        name: valid.name,
                        description: valid.description,
                        comment: valid.comment,
                        start: (valid.date && valid.start_time) ? sqlDate(moment(`${valid.date} ${valid.start_time}`).local().utc()) : undefined,
                        end: (valid.date && valid.end_time) ? sqlDate(moment(`${valid.date} ${valid.end_time}`).local().utc()) : undefined,
                        items: valid.items.filter(_ => !_.deleted)
                    }

                    if (mode === 'finish') {
                        visit.status = 2
                    }

                    if (visit.id < 1) {
                        return this.$chaos('visit', client.post('Criando visita...', `/forms/${this.form.id}/visits`, visit))
                    } else {
                        return this.$chaos('visit', client.put('Salvando visita...', `/forms/${this.form.id}/visits/${visit.id}`, visit))
                    }
                }).then((e) => {
                    const { data } = e

                    if (mode === 'finish') {
                        if (this.onUpdate) {
                            this.onUpdate(data, this.mode)
                        }

                        this.finish(data.form_id, data.id, false)
                    } else if (mode === 'cancel') {
                        if (this.onUpdate) {
                            this.onUpdate(data, this.mode)
                        }

                        this.$refs.finishModal.hide()
                    } else if (mode === 'update') {
                        if (this.onUpdate) {
                            this.onUpdate(data, this.mode)
                        }
                    } else if (mode === 'create') {
                        if (this.onCreate) {
                            this.onCreate(data)
                        }
                    }
                }).catch((e) => {
                    console.error(e)
                }).finally(() => {
                    this.submitting = false
                })
            },
            async loadBase (formId, propertiesIds = [], constructionIds = []) {
                const fetchConstructions = async () => {
                    if (constructionIds.length === 0) {
                        return { data: [] }
                    }
                    if (constructionIds[0] !== null && typeof constructionIds[0] === 'object') {
                        return { data: constructionIds }
                    }
                    // Endpoint aceita até 100 IDs por chamada; chunk se necessário
                    const CHUNK_SIZE = 100
                    const chunks = []
                    for (let i = 0; i < constructionIds.length; i += CHUNK_SIZE) {
                        chunks.push(constructionIds.slice(i, i + CHUNK_SIZE))
                    }
                    const responses = await Promise.all(
                        chunks.map(ids => client.post(null, '/constructions/batch', {
                            form_id: formId,
                            ids: ids,
                        }))
                    )
                    const data = responses.flatMap(r => r.data)
                    return { data }
                }
                const fetchProperties = () => {
                    if (propertiesIds.length === 0) {
                        return Promise.resolve([])
                    }
                    return searchClient.query({
                        query: propertiesQuery,
                        variables: {
                            request: {
                                search: {
                                    idOp: {
                                        in: propertiesIds
                                    }
                                },
                                sort: {},
                                page: 1,
                                limit: 30
                            }
                        }
                    }).then(res => res.data.result.items)
                }
                return Promise.props({
                    form: client.get(null, `/forms/${formId}?simple=true`),
                    properties: fetchProperties(),
                    constructions: await fetchConstructions()
                }).then((res) => {
                    return {
                        form: res.form.data,
                        properties: res.properties,
                        constructions: res.constructions.data
                    }
                })
            },
            load (formId, visitId, append = []) {
                return client.get(null, `/forms/${formId}/visits/${visitId}`).then((res) => {
                    const visit = res.data
                    if (append.length) {
                        for (const _index in append) {
                            const nextPosition = R.reduce((a, b) => R.max(a, b.position), 1, visit.items) + 1

                            if (append.hasOwnProperty(_index)) {
                                const item = append[_index]

                                const exists = visit.items
                                    .find(x => x.item_id === String(item.item_id) && x.type === item.type)

                                if (exists) {
                                    continue;
                                }

                                visit.items.push({
                                    id: 0,
                                    type: item.type,
                                    item_id: item.item_id,
                                    meta: null,
                                    position: nextPosition,
                                    status: 1,
                                    general_rating: null,
                                    price_rating: null,
                                    location_rating: null,
                                    condition_rating: null,
                                    comment: null,
                                    visited_at: null,
                                    deleted: false
                                })
                            }
                        }
                    }
                    return this
                        .loadBase(
                            formId,
                            visit.items.filter(_ => _.type === 'PROPERTY').map(_ => parseInt(_.item_id)),
                            visit.items.filter(_ => _.type === 'CONSTRUCTION').map(_ => parseInt(_.item_id)),
                        )
                        .then(({ form, properties, constructions }) => {
                            visit.items = visit.items.map((item) => {
                                item.deleted = false
                                item.item = null

                                if (item.type === 'PROPERTY') {
                                    item.item = {...properties.find(_ => _.id === parseInt(item.item_id)), itemType: item.type}
                                }

                                if (item.type === 'CONSTRUCTION') {
                                    item.item = {...constructions.find(_ => _.id === parseInt(item.item_id)), itemType: item.type}
                                }

                                return item
                            })

                            const start = moment.utc(visit.event.start)
                            const localStart = start.clone().local()
                            const end = visit.event.end ? moment.utc(visit.event.end) : null
                            const localEnd = end ? end.clone().local() : null
                            return {
                                form,
                                properties,
                                visit: {
                                    id: visit.id,
                                    status: visit.status,
                                    name: visit.event.name,
                                    comment: visit.comment,
                                    description: visit.event.description,
                                    date: formatDate(localStart, 'YYYY-MM-DD'),
                                    start_time: formatDate(localStart, 'HH:mm:ss'),
                                    end_time: formatDate(localEnd, 'HH:mm:ss'),
                                    items: visit.items
                                }
                            }
                        })
                })
            },
            finish (formId, visitId, show = true) {
                this.mode = 'finish'
                this.loading = true

                this.load(formId, visitId).then(({ visit, form, properties }) => {
                    this.form = form
                    visit.items = visit.items.map((item) => {
                        item.status = R.defaultTo(2, item.status === 1 ? null : item.status)
                        item.general_rating = R.defaultTo(10, item.general_rating)
                        item.price_rating = R.defaultTo(null, item.price_rating)
                        item.location_rating = R.defaultTo(null, item.location_rating)
                        item.condition_rating = R.defaultTo(null, item.condition_rating)
                        return item
                    })
                    this.visit = visit

                    this.loading = false
                })

                if (show) {
                    this.$refs.finishModal.show()
                }
            },
            cancel (formId, visitId, show = true) {
                this.mode = 'cancel'
                this.loading = true

                this.load(formId, visitId).then(({ visit, form, properties }) => {
                    this.form = form

                    visit.status = 3
                    visit.items = visit.items.map((item) => {
                        item.status = 3
                        item.general_rating = 0
                        item.price_rating = 0
                        item.location_rating = 0
                        item.condition_rating = 0
                        return item
                    })

                    this.visit = visit

                    this.loading = false
                })

                if (show) {
                    this.$refs.finishModal.show()
                }
            },
            update (formId, visitId, show = true, append = []) {
                this.mode = 'update'
                this.loading = true

                this.load(formId, visitId, append).then(({ visit, form, properties }) => {
                    this.form = form
                    this.visit = visit

                    this.loading = false

                    this.$nextTick(() => this.$refs.title.focus())
                })

                if (show) {
                    this.$refs.modal.show()
                }
            },
            view (formId, visitId, show = true) {
                this.mode = 'view'
                this.loading = true

                this.load(formId, visitId).then(({ visit, form, properties }) => {
                    this.form = form
                    this.visit = visit

                    this.loading = false
                })

                if (show) {
                    this.$refs.viewModal.show()
                }
            },
            create (formId, propertiesIds = [], constructions = []) {
                this.mode = 'create'
                this.loading = true
                this.loadBase(formId, propertiesIds, constructions).then(({ form, properties, constructions }) => {
                    this.form = form
                    const items = [];
                    let count = 0;
                    if (properties && properties.length > 0) {
                        R.forEach( (property) => {
                            count += 1;
                            items.push({
                                id: 0,
                                type: 'PROPERTY',
                                item_id: property.id,
                                item: property,
                                meta: null,
                                position: count,
                                status: 1,
                                general_rating: null,
                                price_rating: null,
                                location_rating: null,
                                condition_rating: null,
                                comment: null,
                                visited_at: null,
                                deleted: false
                            })
                        }, properties)
                    }
                    if (constructions && constructions.length > 0) {
                        R.forEach( (construction) => {
                            count += 1;
                            items.push({
                                id: 0,
                                type: 'CONSTRUCTION',
                                item_id: construction.id,
                                item: construction,
                                meta: null,
                                position: count,
                                status: 1,
                                general_rating: null,
                                price_rating: null,
                                location_rating: null,
                                condition_rating: null,
                                comment: null,
                                visited_at: null,
                                deleted: false
                            })
                        }, constructions)
                    }

                    this.visit = {
                        ...defaultVisit(),
                        items: items
                    }

                    this.loading = false

                    this.$nextTick(() => this.$refs.title.focus())
                })
                this.$refs.modal.show()
            },
            remove (row) {
                row.deleted = true
                this.reorder()
            },
            reorder () {
                const res = R.pipe(
                    R.sortBy(_ => _.position),
                    R.reduce((state, row) => {
                        if (row.deleted) {
                            row.position = -1
                        } else {
                            row.position = state.position
                            state.position += 1
                        }

                        return {
                            ...state,
                            items: [...state.items, row]
                        }
                    }, { position: 1, items: [] })
                )(Vue.util.extend([], this.visit.items))

                this.visit.items = res.items

                // this.visit.items.filter((row) => {
                //     return !row.deleted
                // }).forEach((item, index) => {
                //     return { ...item, position: index + 1 }
                // })
            },
            moveUp (row) {
                if (row.position === 1) {
                    return
                }

                const current = this.visit.items.find(_ => _.position === row.position)
                const up = this.visit.items.find(_ => _.position === row.position - 1)

                current.position = current.position - 1
                up.position = current.position + 1
            },
            moveDown (row) {
                if (row.position === this.visit.items.length) {
                    return
                }

                const current = this.visit.items.find(_ => _.position === row.position)
                const down = this.visit.items.find(_ => _.position === row.position + 1)

                current.position = current.position + 1
                down.position = current.position - 1
            },
            showVisitStatement (formId, visitId, show = true) {
                this.mode = 'visit-statement'
                this.loading = true

                this.load(formId, visitId).then(({ visit, form, properties }) => {
                    this.form = form
                    this.visit = visit
                    this.visitStatement.user = form.user_id

                    this.loading = false
                })

                if (show) {
                    this.$refs.statementModal.show()
                }
            },
            openVisitStatement () {
                const statement = this.visitStatement
                window.open(`/forms/${this.form.id}/new-visit-statement/${this.visit.id}?date=${statement.date || ''}&user=${statement.user || ''}`)
            },
            preAppendVisitSelected (_visit) {
                this.$refs.preAppendItemsModal.hide()

                const visit = Vue.util.extend({}, _visit)

                this.update(this.preAppendItemsForm.formId, visit.id, true, this.preAppendItemsForm.items)
            },
            preAppendItems (form, items) {
                this.preAppendItemsForm.loading = true
                this.preAppendItemsForm.formId = form
                this.preAppendItemsForm.items = items
                this.$refs.preAppendItemsModal.show()

                client.get(null, `/forms/${form}/visits`, { status: 1 }).then((res) => {
                    this.preAppendItemsForm.visits = res.data
                    this.preAppendItemsForm.loading = false
                })
            },
            addProperty () {
                if (!this.addPropertyForm.code) {
                    toastr.error('Código do imóvel vázio')
                    this.$els.addPropertyCode && this.$els.addPropertyCode.focus();
                    return
                }

                searchClient.query({
                    query: propertiesQuery,
                    variables: {
                        request: {
                            search: {
                                userCodeOp: {
                                    in: this.addPropertyForm.code
                                }
                            },
                            sort: {},
                            page: 1,
                            limit: 30
                        }
                    }
                }).then((res) => {
                    this.addPropertyForm.code = null
                    try {
                        const items = res.data.result.items

                        if (items.length > 0) {
                            for (const _index in items) {
                                const nextPosition = R.reduce((a, b) => R.max(a, b.position), 1, this.visit.items) + 1
                                if (items.hasOwnProperty(_index)) {
                                    const property = items[_index];
                                    const exists = this.visit.items
                                        .find(x => x.type === 'PROPERTY' && parseInt(x.item_id) === parseInt(property.id))

                                    if (!exists) {
                                        this.visit.items.push({
                                            id: 0,
                                            type: 'PROPERTY',
                                            item_id: property.id,
                                            item: property,
                                            meta: null,
                                            position: nextPosition,
                                            status: 1,
                                            general_rating: null,
                                            price_rating: null,
                                            location_rating: null,
                                            condition_rating: null,
                                            comment: null,
                                            visited_at: null,
                                            deleted: false
                                        })

                                        toastr.info(`Imóvel ${property.userCode} adicionado`)
                                    }
                                }
                            }
                        } else {
                            toastr.error('Imóvel não encontrado')
                        }
                    } catch (err) {
                        console.error(err)
                        toastr.error('Imóvel não encontrado')
                    }
                })
            },
            notVisited(row) {
                row.status = 3
                row.general_rating = 0
                row.price_rating = 0
                row.location_rating = 0
                row.condition_rating = 0
            },
            visited(row) {
                row.status = 2;
                row.general_rating = null
                row.price_rating = null
                row.location_rating = null
                row.condition_rating = null
            }
        }
    }
</script>


// WEBPACK FOOTER //
// VisitScheduling.vue?0bb50734